module.exports = __webpack_public_path__ + "img/feature-uncover-icon.fe8315a6.svg";